import { request } from '../common/request';

export function usePasswordReset() {
  const initiatePasswordReset = (email: string) =>
    request.post('/users/password/reset', { email });

  const resetPassword = (newPassword: string, token: string) =>
    request.post('/users/password/reset/confirmation', { newPassword, token });

  return { initiatePasswordReset, resetPassword };
}